














import Vue from 'vue';
import { BROADCAST } from '@/mass/models/Broadcast';
import massVuex from '../../vuex/common';

export default Vue.extend({
  mixins: [massVuex],
});
